"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Localization = void 0;
const libs_localization_common_1 = require("libs.localization.common");
/**
 * See documentation at docs/libs/localization.md
 */
class Localization extends libs_localization_common_1.Localization {
    // Have `doc` passed as parameter to this function, because otherwise (if imported from this module instead) it fails to check `db` correctly.
    // Probably an issue due to minification (and how its internal code uses instanceof to assert).
    // Similar for 'getDoc', 'setDoc', 'collection', 'query', 'where', and 'getDocs'.
    configureLocalizationDatabase(doc, getDoc, setDoc, collection, query, where, getDocs, db, entityId) {
        const id = this.getId();
        const isProductStrings = /product_/.test(id);
        const collectionPath = isProductStrings ? `localization` : `entities/${entityId}/localization`;
        const docRef = doc(db, collectionPath, id);
        const getLocalizationResourceDocRef = (locale, version) => doc(db, `entities/${entityId}/localization/${id}/localization_resources`, `${locale}~${version}`);
        this.databaseEntryExists = function () {
            return __awaiter(this, void 0, void 0, function* () {
                return (yield getDoc(docRef)).exists();
            });
        };
        this.getDatabaseEntry = function () {
            return __awaiter(this, void 0, void 0, function* () {
                return (yield getDoc(docRef)).data();
            });
        };
        this.setDatabaseEntry = function (entry) {
            return __awaiter(this, void 0, void 0, function* () {
                yield setDoc(docRef, entry);
            });
        };
        this.updateDatabaseEntry = function (entry) {
            return __awaiter(this, void 0, void 0, function* () {
                yield setDoc(docRef, entry, { merge: true });
            });
        };
        this.getDatabaseLocalizationResourceEntry = function (locale, version) {
            return __awaiter(this, void 0, void 0, function* () {
                if (isProductStrings) {
                    return;
                }
                return (yield getDoc(getLocalizationResourceDocRef(locale, version))).data();
            });
        };
        this.setDatabaseLocalizationResourceEntry = function (locale, version, entry) {
            return __awaiter(this, void 0, void 0, function* () {
                if (isProductStrings) {
                    return;
                }
                yield setDoc(getLocalizationResourceDocRef(locale, version), entry);
            });
        };
        this.getDatabaseLocalizationResourceEntries = function (locale) {
            return __awaiter(this, void 0, void 0, function* () {
                if (isProductStrings) {
                    return;
                }
                const colRef = collection(db, `entities/${entityId}/localization/${id}/localization_resources`);
                const q = query(colRef, where('__name__', '>=', locale), where('__name__', '<', locale + '\uf8ff'));
                const querySnapshot = yield getDocs(q);
                return querySnapshot.docs.map((doc) => doc.data());
            });
        };
        this.updateDatabaseLocalizationResourceEntry = function (locale, version, entry) {
            return __awaiter(this, void 0, void 0, function* () {
                if (isProductStrings) {
                    return;
                }
                yield setDoc(getLocalizationResourceDocRef(locale, version), entry, { merge: true });
            });
        };
    }
}
exports.Localization = Localization;
//# sourceMappingURL=localization.js.map